import { css as t } from "@microsoft/fast-element";
import { normalize as n } from "../common/normalize.js";
import { display as a, PropertyStyleSheetBehavior as p } from "@matrix42/fast-foundation";
import { typography as s } from "../styles/typography.js";
import { designTokens as e } from "../design-tokens.js";
function o(i, r) {
  return new p("orientation", i, r);
}
const l = t`
  .stepper-header {
    /* Layout */
    display: flex;
    flex-direction: column;
  }

  .stepper-header-steps {
    /* Layout */
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    gap: ${e.spacing[7]};
  }

  .stepper-container {
    /* Layout */
    display: flex;
    flex-direction: column;
    gap: ${e.spacing[10]};
  }

  .divider {
    /* Layout */
    width: ${e.spacing[8]};
    height: ${e.borderWidth.xs};
    /* Style */
    background-color: ${e.color.neutral[70]};
  }
`, c = t`
  .stepper-header-steps {
    /* Layout */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
    gap: ${e.spacing[7]};
  }

  .stepper-container {
    /* Layout */
    display: flex;
    flex-direction: row;
    gap: ${e.spacing[12]};
  }

  .divider {
    /* Layout */
    margin-left: calc(1.313 * ${e.spacing[4]});
    height: ${e.spacing[8]};
    width: ${e.borderWidth.xs};
    /* Style */
    background-color: ${e.color.neutral[70]};
  }

  .divider-hidden {
    /* Layout */
    width: 0 !important;
  }
`, h = t`
  ${n}
  ${a("block")}
  .control {
    /* Layout */
    display: flex;
    flex-direction: column;
    gap: ${e.spacing[10]};
    justify-content: space-between;
    height: 100%;

    /* Typography */
    ${s("p", "regular")}
  }

  :host {
    height: 100%;
  }

  .stepper-header-steps {
    margin-top: calc(-1 * ${e.spacing[1]});
    margin-left: calc(-1 * ${e.spacing[1]});
  }

  .step-icon-container {
    /* Layout */
    display: inline-flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
    cursor: pointer;
  }

  .stepper-footer {
    /* Layout */
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: ${e.spacing[6]} 0;

    /* Style */
    border-top: ${e.borderWidth.xs} solid
      ${e.color.neutral[70]};
  }

  .footer-buttons-right,
  .footer-buttons-left {
    /* Layout */
    display: flex;
    gap: ${e.spacing[2]};
  }

  .footer-buttons-right {
    /* Layout */
    justify-content: right;
  }
`.withBehaviors(
  o("horizontal", l),
  o("vertical", c)
);
export {
  h as stepperStyles
};
